import styled from 'styled-components';

export const ContainerFilterDataIntegration = styled.div`
  border-radius: 0.625rem 0.625rem 0 0;
  background: #FFF;

  margin: 0.9375rem 0;
`;
